import { connect } from 'react-redux';

import { createMerchant } from '@/features/merchantCreatePage/actions';

import NewMerchant from './component';

const mapDispatchToProps = { createMerchant };

export default connect(null, mapDispatchToProps)(NewMerchant);
